import React, { useState, useEffect } from "react";
import { Loader, Flex, Text, Button } from "@fluentui/react-northstar";
import { Redirect } from "react-router-dom";
import { app } from "@microsoft/teams-js";
import { useSSOAuth } from "./SSOAuthService";
import { getApiBaseUrl, parseJwt } from "./PresenceSubscriptionCard";

/**
 * SyncRouter: checks sync config and redirects to Setup or Dashboard.
 */
const SyncRouter = () => {
    const { getToken, loading: authLoading } = useSSOAuth();
    const [loading, setLoading] = useState(true);
    const [setupComplete, setSetupComplete] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        app.initialize().then(() => {
            app.notifyAppLoaded();
            app.notifySuccess();
        });
    }, []);

    useEffect(() => {
        const checkSyncConfig = async () => {
            try {
                const token = await getToken(['User.Read.All', 'Presence.Read.All', "Calendars.Read", 'offline_access']);
                if (!token) return;

                const decoded = parseJwt(token);
                const tenantId = decoded ? decoded.tid : null;
                if (!tenantId) return;

                const baseUrl = getApiBaseUrl();
                const url = `${baseUrl}/MSTeamsUser/syncConfig/${tenantId}`;

                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                });

                if (response.ok) {
                    const data = await response.json();
                    setSetupComplete(Boolean(data.setupComplete));
                } else {
                    setSetupComplete(false);
                }
            } catch (e) {
                console.error("Failed to check sync config:", e);
                setError(e.message || "Konfiguration konnte nicht geladen werden.");
            } finally {
                setLoading(false);
            }
        };
        if (!authLoading) {
            checkSyncConfig();
        }
    }, [getToken, authLoading]);

    if (loading || authLoading) {
        return (
            <Flex fill column hAlign="center" vAlign="center" style={{ height: '80vh' }}>
                <Loader label="Konfiguration wird geladen..." />
            </Flex>
        );
    }

    if (error) {
        return (
            <Flex fill column hAlign="center" vAlign="center" style={{ height: '80vh', gap: 12 }}>
                <Text error content={error} />
                <Button content="Erneut versuchen" text onClick={() => window.location.reload()} />
            </Flex>
        );
    }

    if (setupComplete) {
        return <Redirect to="/sync/dashboard" />;
    }

    return <Redirect to="/sync/setup" />;
};

export default SyncRouter;
